import React, { useState } from 'react';
import SubPagesLayout from 'layouts/SubPagesLayout';
import TitleSection from 'components/common/TitleSection';
import CommonTab from 'components/common/tabs';
import TabsListing from 'components/common/tabs/TabsListing';
import {
  coperativeData,
  corporateMeetingData,
  executiveData,
  pressConferenceData,
  conferenceData,
  businessData,
  exhibitionData,
  awardData,
  techData,
  corporativeCardData,
  techCardData,
  awardCardData,
  exhibitionCardData,
  businessMeetCardData,
  conferenceCardData,
  pressCardData,
  executiveCardData,
  corporateMeetCardData,
} from 'helpers/portfolioHelper';

const PrivateEvents = () => {
  const titleDetail = {
    upperTitle: '',
    middleTitle: 'CORPORATIVE EVENTS PORTFOLIO',
    lowerTitle: 'WE HAVE BEST SOLUTIONS FOR ALL',
  };
  const [currentTab, setCurrentTab] = useState('Product Lunches');

  let [tabList] = useState([
    {
      id: 1,
      name: 'Product Lunches',
      component: (
        <TabsListing list={coperativeData} cardData={corporativeCardData} />
      ),
    },
    {
      id: 2,
      name: 'Corporate Meetings',
      component: (
        <TabsListing
          list={corporateMeetingData}
          cardData={corporateMeetCardData}
        />
      ),
    },
    {
      id: 3,
      name: 'Executive Events',
      component: (
        <TabsListing list={executiveData} cardData={executiveCardData} />
      ),
    },
    {
      id: 4,
      name: 'Press Conference',
      component: (
        <TabsListing list={pressConferenceData} cardData={pressCardData} />
      ),
    },
    {
      id: 5,
      name: 'Conference Meeting',
      component: (
        <TabsListing list={conferenceData} cardData={conferenceCardData} />
      ),
    },
    {
      id: 6,
      name: 'Business Retrive Meeting',
      component: (
        <TabsListing list={businessData} cardData={businessMeetCardData} />
      ),
    },
    {
      id: 7,
      name: 'Exhibitions Meeting',
      component: (
        <TabsListing list={exhibitionData} cardData={exhibitionCardData} />
      ),
    },
    {
      id: 8,
      name: 'Award Ceremonies',
      component: <TabsListing list={awardData} cardData={awardCardData} />,
    },
    {
      id: 9,
      name: 'Tech Event',
      component: <TabsListing list={techData} cardData={techCardData} />,
    },
  ]);
  return (
    <section className='portfolioPage DBlock relative py-10 sm:py-12 px-6 sm:px-10 bg-eventLightPink'>
      <div className='max-w-7xl mx-auto'>
        <TitleSection titleDetail={titleDetail} />
        <CommonTab
          tabList={tabList}
          setCurrentTab={setCurrentTab}
          currentTab={currentTab}
        />
      </div>
    </section>
  );
};

export default SubPagesLayout({ route: 'portfolio/corporative events' })(
  PrivateEvents
);
